import React, { useEffect, useState } from "react";
import { getServices } from "../../Services/terminal";
import Select from "react-tailwindcss-select";
import { useParams } from "react-router-dom";
import { useTerminalConfig } from "../../Path/NewTerminalConfigs";
import { isNil, uniq } from "lodash-es";
import AddService from "./AddService";
import ServiceEditRequest from "./ServiceEditRequest";
import { t } from "i18next";

const ServiceForm = () => {
    const { id } = useParams();
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const [services, setServices] = useState([]);
    const [openAddService, setOpenAddService] = useState(false);

    // useEffect(() => {
    //     getServices(terminalConfig?.terminalId).then((ser) => {
    //         const serviceData = ser.data?.data
    //         setServices(serviceData)
    //         console.log("Servicedata :", serviceData)
    //         const SS = serviceData.filter((s) => terminalConfig?.serviceIds?.includes(s.id));
    //         setTerminalConfig((prev) => ({ ...prev, selectedServices: SS ?? [], }))
    //     });
    // }, [terminalConfig])
    useEffect(() => {
        if (!terminalConfig?.terminalId) return;

        getServices(terminalConfig?.terminalId).then((ser) => {
            const serviceData = ser.data?.data || [];
            setServices(serviceData);

            const selectedServices = serviceData
                .filter((s) => terminalConfig?.serviceIds?.includes(s.id))
                .map((s) => ({
                    ...s,
                    value: s.id,
                    label: s.title,
                }));

            setTerminalConfig((prev) => ({
                ...prev,
                selectedServices: selectedServices ?? [],
            }));
        });
    }, [terminalConfig?.terminalId]);

    async function fetchServices() {
        try {
            const res = await getServices(terminalConfig?.terminalId);
            const newServices = res.data?.data || [];
            setServices(newServices);
            setTerminalConfig((prev) => ({
                ...prev, selectedServices: prev?.selectedServices.map((ser) => {
                    const updated = newServices.find((s) => s.id === ser.id);
                    return updated ? { ...ser, ...updated } : ser;
                }) ?? [],
            }))
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    }

    return (
        <div className="mt-6">
            <h2 className="text-xl font-semibold text-white">{t("Services")}</h2>
            <ServiceEditRequest onClose={(refetchServices) => {
                if (refetchServices) {
                    fetchServices();
                }
            }} />
            <div className="flex flex-col gap-2 mb-4 mt-2 max-w-sm">
                <label for="countries" class="block mb-2 text-sm font-medium text-white">{t("choose_services")}</label>
                <Select
                    primaryColor="indigo"
                    label={t("selectServiceLabel")}
                    placeholder={t("selectServiceLabel")}
                    options={services.filter((s) => !terminalConfig?.selectedServices?.find((ser) => ser.id === s.id)).map((cities) => ({ value: cities.id, label: cities.title, ...cities }))}
                    onChange={(val) => {
                        if (isNil(terminalConfig.selectedServices) || terminalConfig.selectedServices?.length < 3) {
                            setTerminalConfig((prev) => ({ ...prev, selectedServices: (uniq([...prev.selectedServices, val])) ?? [] }))
                        }
                    }}
                />
            </div>
            {terminalConfig.selectedServices?.length >= 3 && <p className="text-md text-red-400">{t("maximum_limit_service")}</p>}
            <button
                onClick={() => setOpenAddService(true)}
                className="text-sm text-primary hover:underline mt-2 bg-blue-600 py-2 px-4 rounded font-semibold text-white"
            >
                {t("addServiceLabel")}
            </button>
            {openAddService && <AddService terminalId={id} isAdmin={terminalConfig?.isAdmin} createdBy={terminalConfig?.createdBy} close={(refetchServices) => {
                setOpenAddService(false);
                if (refetchServices) {
                    getServices(terminalConfig?.terminalId).then((ser) => setServices(ser.data?.data));
                }
            }} />}
        </div>
    );
}

export default ServiceForm;
